import React from 'react';

import MenuIcon from '@mui/icons-material/Menu';
import { Box, IconButton } from '@mui/material';

import { IHeaderBarProp } from 'src/components/common/types/headerTypes';
import ProfileImage from 'src/features/profile/components/ProfileImage';

const HeaderBar: React.FC<IHeaderBarProp> = ({
	toggleNavbar,
}: IHeaderBarProp): React.JSX.Element => {
	return (
		<Box
			className='w-full h-[4.5rem] bg-white border-b border-[#00000020] items-center hidden lg:flex'
			data-testid='HeaderBar'
		>
			<span
				style={{
					marginLeft: '24px',
				}}
			>
				<IconButton onClick={toggleNavbar} sx={{ cursor: 'pointer' }}>
					<MenuIcon />
				</IconButton>
			</span>
			<Box sx={{ flexGrow: 1 }}></Box>
			<Box sx={{ marginRight: '1px' }}>
				<ProfileImage />
			</Box>
		</Box>
	);
};

export default HeaderBar;
